// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2019 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-display-dimensions-widget {
  position: absolute;
  cursor: default;
  top: 2px;
  left: 2px;
  background-color: rgba(0, 0, 0, 0.3);
}

.neuroglancer-display-dimensions-widget-dimension-grid {
  display: grid;
  grid-template-rows: 0fr 0fr 0fr 0fr;
  grid-template-columns: 0fr 0fr 0fr;
}

.neuroglancer-display-dimensions-widget input {
  outline: 0px;
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  margin: 0;
  border: 0;
  padding: 2px;
}

.neuroglancer-display-dimensions-widget input,
.neuroglancer-display-dimensions-widget {
  font-family: monospace;
  color: white;
}

.neuroglancer-display-dimensions-widget-dimension:hover {
  outline: 1px solid black;
}

.neuroglancer-display-dimensions-widget-name[data-is-valid="false"] {
  text-decoration: solid underline red;
}

.neuroglancer-display-dimensions-widget-scale-factor {
  text-align: right;
  align-items: end;
  display: inline-block;
  white-space: nowrap;
  margin-left: 2px;
}

.neuroglancer-display-dimensions-widget-scale {
  display: inline-block;
  white-space: nowrap;
  padding-left: 10px;
}

.neuroglancer-display-dimensions-widget-scale:not(:empty)::before {
  content: "(";
}

.neuroglancer-display-dimensions-widget-scale:not(:empty)::after {
  content: ")";
}

.neuroglancer-display-dimensions-widget-scale-factor::after {
  content: "×";
}

.neuroglancer-display-dimensions-widget-scale {
  text-align: right;
  margin-left: 5px;
}

.neuroglancer-display-dimensions-widget:not(:hover):not([data-active="true"])
  .neuroglancer-display-dimensions-widget-scale-factor,
.neuroglancer-display-dimensions-widget:not(:hover):not([data-active="true"])
  .neuroglancer-display-dimensions-widget-scale,
.neuroglancer-display-dimensions-widget:not(:hover):not([data-active="true"])
  .neuroglancer-display-dimensions-widget-default,
.neuroglancer-display-dimensions-widget:not(:hover):not([data-active="true"])
  .neuroglancer-depth-range-widget-grid,
.neuroglancer-display-dimensions-widget:not(:hover):not([data-active="true"])
  .neuroglancer-depth-range-relative-checkbox-label {
  display: none;
}

.neuroglancer-display-dimensions-widget-dimension[data-is-modified="true"]
  .neuroglancer-display-dimensions-widget-scale-factor,
.neuroglancer-display-dimensions-widget-dimension[data-is-modified="true"]
  .neuroglancer-display-dimensions-widget-scale {
  visibility: hidden;
}

.neuroglancer-display-dimensions-widget *:focus {
  outline: 0px;
}

.neuroglancer-display-dimensions-widget-default {
  grid-row: 4;
  grid-column-start: 1;
  grid-column-end: 3;
  display: inline-block;
  white-space: nowrap;
}

.neuroglancer-display-dimensions-widget-default input {
  margin-right: 3px;
}

.neuroglancer-depth-range-widget-grid {
  margin-top: 1em;
  display: grid;
  display: grid;
  grid-template-columns: 0fr 0fr 0fr;
  grid-auto-rows: 0fr;
}

.neuroglancer-depth-range-widget-dimension-names:not(:empty)::before {
  content: "(";
}

.neuroglancer-depth-range-widget-dimension-names:not(:empty)::after {
  content: ")";
}

.neuroglancer-depth-range-widget-dimension-names {
  margin-left: 1ch;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/widget/display_dimensions_widget.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,aAAa;AACf;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/**\n * @license\n * Copyright 2019 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-display-dimensions-widget {\n  position: absolute;\n  cursor: default;\n  top: 2px;\n  left: 2px;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n\n.neuroglancer-display-dimensions-widget-dimension-grid {\n  display: grid;\n  grid-template-rows: 0fr 0fr 0fr 0fr;\n  grid-template-columns: 0fr 0fr 0fr;\n}\n\n.neuroglancer-display-dimensions-widget input {\n  outline: 0px;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n  margin: 0;\n  border: 0;\n  padding: 2px;\n}\n\n.neuroglancer-display-dimensions-widget input,\n.neuroglancer-display-dimensions-widget {\n  font-family: monospace;\n  color: white;\n}\n\n.neuroglancer-display-dimensions-widget-dimension:hover {\n  outline: 1px solid black;\n}\n\n.neuroglancer-display-dimensions-widget-name[data-is-valid=\"false\"] {\n  text-decoration: solid underline red;\n}\n\n.neuroglancer-display-dimensions-widget-scale-factor {\n  text-align: right;\n  align-items: end;\n  display: inline-block;\n  white-space: nowrap;\n  margin-left: 2px;\n}\n\n.neuroglancer-display-dimensions-widget-scale {\n  display: inline-block;\n  white-space: nowrap;\n  padding-left: 10px;\n}\n\n.neuroglancer-display-dimensions-widget-scale:not(:empty)::before {\n  content: \"(\";\n}\n\n.neuroglancer-display-dimensions-widget-scale:not(:empty)::after {\n  content: \")\";\n}\n\n.neuroglancer-display-dimensions-widget-scale-factor::after {\n  content: \"×\";\n}\n\n.neuroglancer-display-dimensions-widget-scale {\n  text-align: right;\n  margin-left: 5px;\n}\n\n.neuroglancer-display-dimensions-widget:not(:hover):not([data-active=\"true\"])\n  .neuroglancer-display-dimensions-widget-scale-factor,\n.neuroglancer-display-dimensions-widget:not(:hover):not([data-active=\"true\"])\n  .neuroglancer-display-dimensions-widget-scale,\n.neuroglancer-display-dimensions-widget:not(:hover):not([data-active=\"true\"])\n  .neuroglancer-display-dimensions-widget-default,\n.neuroglancer-display-dimensions-widget:not(:hover):not([data-active=\"true\"])\n  .neuroglancer-depth-range-widget-grid,\n.neuroglancer-display-dimensions-widget:not(:hover):not([data-active=\"true\"])\n  .neuroglancer-depth-range-relative-checkbox-label {\n  display: none;\n}\n\n.neuroglancer-display-dimensions-widget-dimension[data-is-modified=\"true\"]\n  .neuroglancer-display-dimensions-widget-scale-factor,\n.neuroglancer-display-dimensions-widget-dimension[data-is-modified=\"true\"]\n  .neuroglancer-display-dimensions-widget-scale {\n  visibility: hidden;\n}\n\n.neuroglancer-display-dimensions-widget *:focus {\n  outline: 0px;\n}\n\n.neuroglancer-display-dimensions-widget-default {\n  grid-row: 4;\n  grid-column-start: 1;\n  grid-column-end: 3;\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.neuroglancer-display-dimensions-widget-default input {\n  margin-right: 3px;\n}\n\n.neuroglancer-depth-range-widget-grid {\n  margin-top: 1em;\n  display: grid;\n  display: grid;\n  grid-template-columns: 0fr 0fr 0fr;\n  grid-auto-rows: 0fr;\n}\n\n.neuroglancer-depth-range-widget-dimension-names:not(:empty)::before {\n  content: \"(\";\n}\n\n.neuroglancer-depth-range-widget-dimension-names:not(:empty)::after {\n  content: \")\";\n}\n\n.neuroglancer-depth-range-widget-dimension-names {\n  margin-left: 1ch;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
